import React, { useEffect, useState } from "react";
import { Listing, ListItem } from "../../../widget/common/ui/Listing";
import Loader from "../../../widget/common/ui/Loader";
import Center from "../../../widget/common/ui/Center";
import { TextBlock } from "../../../widget/common/ui/Text";
import Div from "../../../widget/common/ui/Div";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";
import { AppLink } from "../../../model/home/BranchInfoModel";

const EmailList = (props: {
  emailList: AppLink[] | undefined;
  isModal?: boolean | false;
}) => {
  const emailList = props.emailList;
  const isModal: boolean = props.isModal ?? false;

  const [emails, setEmails] = useState<AppLink[] | undefined>(undefined);

  const branchDetail = useSelector(
    (state: RootState) => state.home.branchDetail
  );

  useEffect(() => {
    if (isModal && branchDetail !== undefined) {
      setEmails(branchDetail?.email_list!);
    } else {
      setEmails(emailList);
    }
    // eslint-disable-next-line
  }, [emailList]);

  return (
    <>
      {emails === undefined ? (
        <Center>{Loader.normal()}</Center>
      ) : (
        <Listing>
          {(emails ?? []).map((email, key) => (
            <ListItem key={key}>
              <a href={`mailto:${email.value}`}>
                <Div fontName="book" color="theme-label" fontSize="16_17">
                  <TextBlock fontName="bold">{email.key}</TextBlock>
                  <TextBlock fontSize="13_14" textColor="blue3">
                    {email.value}
                  </TextBlock>
                </Div>
              </a>
            </ListItem>
          ))}
        </Listing>
      )}
    </>
  );
};
export default EmailList;
